export const escapeRegExp = (query: string) => query?.replace(/[.*+?^${}()|[\]\\]/g, '\\$&') || '';

export const searchRegex = (searchQuery: string): RegExp => new RegExp(escapeRegExp(searchQuery), 'i');

export const matchesSearchQuery = (searchQuery: string, value: string) => (
  value.search(searchRegex(searchQuery)) !== -1
);

export const getSearchMatch = (str: string, searchQuery: string) => str.match(RegExp(`(.*)(${escapeRegExp(searchQuery)})(.*)`, 'i'));
